import { render, staticRenderFns } from "./picture-preview-box.vue?vue&type=template&id=72735e82&scoped=true&lang=pug"
import script from "./picture-preview-box.vue?vue&type=script&lang=js"
export * from "./picture-preview-box.vue?vue&type=script&lang=js"
import style0 from "./templates/multimedia-box/multimedia-box.scss?vue&type=style&index=0&id=72735e82&prod&lang=scss&scoped=true&external"
import style1 from "./picture-preview-box.vue?vue&type=style&index=1&id=72735e82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72735e82",
  null
  
)

export default component.exports